import { createReducer, on } from "@ngrx/store";
import * as AuthActions from '../actions/auth.action';


export interface AuthState {
    user: any;
    error: any;
    isAuthenticated: boolean | undefined;
  }
  
  export const initialState: AuthState = {
    user: null,
    error: null,
    isAuthenticated: true,
  };
  
  export const authReducer = createReducer(
    initialState,
    on(AuthActions.login, state => ({ ...state, error: null })),
    on(AuthActions.loginSuccess, (state) => ({ ...state, error: null,isAuthenticated:true})),
    on(AuthActions.loginFailure, (state, { error }) => ({ ...state,isAuthenticated: false ,error })),
    on(AuthActions.logout, () => initialState),
    on(AuthActions.checkAuthStatus, state => ({ ...state })),
    on(AuthActions.checkAuthStatusSuccess, (state, { isAuthenticated }) => ({...state,isAuthenticated})),
    on(AuthActions.checkAuthStatusFailure, (state, { error }) => ({ ...state, isAuthenticated: false, error })),
  );